import axios from "axios";
import AuthService from "./AuthService";

class FeedbackService {
    constructor() {
        this.apiUrl = `${process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com"}/feedback`;
    }

    async listarAreas() {
        try {
            if (!AuthService.getToken()) await AuthService.login();

            const response = await axios.get(`${this.apiUrl}/areas`, {
                headers: { Authorization: `Bearer ${AuthService.getActiveToken()}` }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao listar áreas de feedback:", error);
            throw error;
        }
    }

    async registrarFeedback(dadosFeedback) {
        try {
            if (!AuthService.getToken()) await AuthService.login();

            const response = await axios.post(`${this.apiUrl}/registrar`, dadosFeedback, {
                headers: { 
                    Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao registrar feedback:", error);
            throw error;
        }
    }

    async consultarFeedbacks(cdCliente, dataInicial = null, dataFinal = null) {
        try {
            if (!AuthService.getToken()) await AuthService.login();

            const params = {};
            if (dataInicial) params.dataInicial = dataInicial;
            if (dataFinal) params.dataFinal = dataFinal;

            const response = await axios.get(`${this.apiUrl}/consultar/${cdCliente}`, {
                headers: { Authorization: `Bearer ${AuthService.getActiveToken()}` },
                params: params
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao consultar feedbacks:", error);
            throw error;
        }
    }
}

export default new FeedbackService();